module.exports = __webpack_public_path__ + "static/img/14001023.a250088e.png";